'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { AlertRootContext } from './context/alert-root.context';
import { alertBodyRecipe } from './styles/alert-body.styles';
import type { AlertBodyPropsInterface } from './types/alert-body.types';

/**
 * @since 10.0.0
 */
export const AlertBody = forwardRef<HTMLDivElement, AlertBodyPropsInterface>(
  (props: AlertBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(AlertRootContext);

    const styles = css(alertBodyRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Alert.Body"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_alert__body', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

AlertBody.displayName = 'Alert.Body';
